import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
  CAvatar,
  // CBadge,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react-pro'
import {
  // cilBell,
  // cilCreditCard,
  // cilCommentSquare,
  // cilEnvelopeOpen,
  // cilFile,
  // cilLockLocked,
  // cilSettings,
  // cilTask,
  // cilUser,
  cilAccountLogout,
  cilUser,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import avatar8 from './../../assets/images/avatars/8.jpg'
import Swal from 'sweetalert2'

const AppHeaderDropdown = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Logout function
  const handleLogout = () => {
    // Remove token from sessionStorage
    sessionStorage.removeItem('token')
    Swal.fire({
      title: 'Logged out successfully!',
      icon: 'success',
      confirmButtonText: 'Ok',
    })
    // Dispatch a logout action to Redux if necessary
    dispatch({ type: 'LOGOUT' })

    // Navigate to login page
    navigate('/')
  }

  return (
    <CDropdown variant="nav-item" alignment="end">
      <CDropdownToggle className="py-0" caret={false}>
        <CAvatar src={avatar8} size="md" status="success" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        <CDropdownHeader className="bg-body-secondary text-body-secondary fw-semibold rounded-top mb-2">
          {t('account')}
        </CDropdownHeader>
        {/* <CDropdownItem href="#">
          <CIcon icon={cilBell} className="me-2" />
          {t('updates')}
          <CBadge color="info-gradient" className="ms-2">
            42
          </CBadge>
        </CDropdownItem> */}
        {/* Other menu items */}
        <CDropdownDivider />
        <CDropdownItem>
          <CIcon icon={cilUser} className="me-2" />
          {t('View Profile')}
        </CDropdownItem>
        {/* Logout button */}
        <CDropdownItem onClick={handleLogout}>
          <CIcon icon={cilAccountLogout} className="me-2" />
          {t('logout')}
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
